var React = require('react');

function Mark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon/mark"),React.createElement("g",{"id":"icon/mark","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Group","transform":"translate(0.133316, 17.000000)","fill":"currentColor"},[React.createElement("path",{"d":"M31.6167728,15.3007912 L31.6167728,7.10542736e-15 C23.10169,0.115516484 16.2131465,6.8849011 16,15.3007912 L31.6167728,15.3007912 Z","id":"Fill-4","key":0}),React.createElement("path",{"d":"M15.6167728,15.3007912 L15.6167728,7.10542736e-15 C7.10169002,0.115516484 0.213146497,6.8849011 -6.67910172e-13,15.3007912 L15.6167728,15.3007912 Z","id":"Fill-4","key":1})]))]);
}

Mark.defaultProps = {"width":"32px","height":"32px","viewBox":"0 0 32 32","version":"1.1"};

module.exports = Mark;

Mark.default = Mark;
